<style lang="less">
  @import "./guidingWay.less";
</style>

<template>
  <div class="reserve-navigation">
    <!--<van-field v-model="bdSearchPlace" placeholder="可输入地点进行搜索" maxlength="30" class="reserve-navigation-search" id="picker-input" />-->
    <!--<ReserveNavigationBtn msg="Welcome to Your Vue.js App"/>-->
    <div id="reserve-map"></div>
    <div id="pickerBox" v-if="!loadingMap">
      <input id="picker-input" class="reserve-navigation-picker" placeholder="可输入地点进行搜索" maxlength="30"/>
      <div id="poiInfo"></div>
    </div>
  </div>
</template>

<script>
import guidingWay from './guidingWay.js'
export default {
  ...guidingWay
}
</script>
